import { z } from 'zod'

export const RCancelReason = z.object({
	CancelCategoryName: z.string(),
	CancelReasonName: z.string(),
	CancelReasonDescription: z.nullable(z.string()),
	PriorToFormStart: z.boolean(),
})

export type CancelReason = z.infer<typeof RCancelReason>
